import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { R } from '@/lib/routes';

// Generic, information-free 404. Rendered for: truly missing routes, AND for any
// unauthenticated/unauthorized access to a real route — so restricted paths are
// indistinguishable from non-existent ones (never a 401/403 that confirms a route).
export default function Generic404({ logScan = false }) {
  useEffect(() => {
    if (logScan) {
      api.post('/security/event', { path: window.location.pathname, invalidate: false }).catch(() => {});
    }
  }, [logScan]);

  return (
    <div data-testid="generic-404" className="kesar-bg flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <div className="font-head text-7xl font-extrabold tracking-tight text-stone-300">404</div>
      <p className="mt-3 text-sm font-semibold text-stone-500">This page could not be found.</p>
      <Link to={R.login} className="mt-6 text-xs font-semibold text-stone-400 underline-offset-4 hover:text-stone-700 hover:underline">
        Return to homepage
      </Link>
    </div>
  );
}
